import * as React from "react";
import type { SVGProps } from "react";
const SvgTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 5a1 1 0 0 0 0 2zm18 2a1 1 0 1 0 0-2zm-2-1h1a1 1 0 0 0-1-1zM5 20H4zM7 6a1 1 0 0 0 2 0zm3-4V1zm4 0V1zm1 4a1 1 0 1 0 2 0zM3 7h2V5H3zm2 0h16V5H5zm13-1v14h2V6zm0 14a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 20 20zm-.293.707A1 1 0 0 1 17 21v2a3 3 0 0 0 2.121-.879zM17 21H7v2h10zM7 21a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 7 23zm-.707-.293A1 1 0 0 1 6 20H4a3 3 0 0 0 .879 2.121zM6 20V6H4v14zM5 7h14V5H5zm4-1V4H7v2zm0-2a1 1 0 0 1 .293-.707L7.879 1.879A3 3 0 0 0 7 4zm.293-.707A1 1 0 0 1 10 3V1a3 3 0 0 0-2.121.879zM10 3h4V1h-4zm4 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 14 1zm.707.293A1 1 0 0 1 15 4h2a3 3 0 0 0-.879-2.121zM15 4v2h2V4z"
    />
  </svg>
);
export default SvgTrash;
